import { useCallback } from "react";
import { useApiBase } from '../base/api-baixas-base'

export const useGetListarContatos = () => {
    const { invocarApi, ...props } = useApiBase();

    const getListarContatos = useCallback(
        (representanteId: string) => {

            let queryFinal = representanteId.length !== 0 ? `?representanteId=${representanteId}` : '';
            return invocarApi({
                url: `v1/Operacao/Representante/contatos${queryFinal}`,
                method: 'GET',
                enviarTokenUsuario: false,
            })
        },
        [invocarApi],
    )
    return {
        getListarContatos,
        ...props
    }
}
